import { axiosRequest } from './../../service/axios';

export const getList = (id) => {
  const url = `subscriptions/list/${id}`;
  const options = {
    method: 'get',
  };
  const axiosData = {
    url,
    options,
  };
  return axiosRequest(axiosData);
};


export const deleteSubscription = (id) => {
  const url = `subscriptions/delete/${id}`;
  const axiosData = {
    url,
  };
  return axiosRequest(axiosData);
};

export const getAddFormData = () => {
  const url = 'subscriptions/create-form-data';
  const options = {
    method: 'get',
  };
  const axiosData = {
    url,
    options,
  };
  return axiosRequest(axiosData);
};

export const getEditFormData = (id) => {
  const url = `subscriptions/edit-form-data/${id}`;
  const options = {
    method: 'get',
  };
  const axiosData = {
    url,
    options,
  };
  return axiosRequest(axiosData);
};

export const addNewSubscription = (data) => {
  const url = 'subscriptions/store';
  const axiosData = {
    url,
    data,
  };
  return axiosRequest(axiosData);
};

export const updateSubscription = (data, id) => {
  const url = `subscriptions/update/${id}`;
  const axiosData = {
    url,
    data,
  };
  return axiosRequest(axiosData);
};

export const authorizePdfDownload = (id) => {
  const url = `subscriptions/${id}/authorize-print`;
  const axiosData = {
    url,
  };
  return axiosRequest(axiosData);
};
